function formatMoney(cents) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "${{amount}}";
    var withoutZero = arguments.length > 2 ? arguments[2] : undefined;
  
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
  
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ",";
      decimal = decimal || ".";
  
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";
  
      if (withoutZero) {
        centsAmount = centsAmount.replace(/[\.,]0{2}/, "");
      }
  
      return dollarsAmount + centsAmount;
    }
  
    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
  
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
  
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
  
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
  
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;
  
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }
  
    return format.replace(placeholderRegex, value);
  }